<template>
  <div class="container">
    <div class="row">
      <div class="col d-flex justify-content-around">
        <button
          class="btn btn-primary btn-sm mt-3"
          v-for="o in orgs"
          :key="o.id"
          @click="selectOrg(o)"
        >
          {{ o.name }}
        </button>
      </div>
    </div>
  </div>
</template>
<script setup>
import {
  collection,
  query,
  where,
  onSnapshot,
  doc,
  updateDoc,
} from "firebase/firestore";
import { ref, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "../../store/index";
import { auth, db } from "../../firebase/config";
import dayjs from "dayjs";
var unsubscribe;
const store = useStore();
const months = ref([
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
]);
const orgs = ref([]);
onBeforeUnmount(() => {
  unsubscribe();
});
onMounted(() => {
  const q = query(
    collection(db, "orgs"),
    where("user", "==", auth.currentUser.uid)
  );
  unsubscribe = onSnapshot(q, (querySnapshot) => {
    const cities = [];
    querySnapshot.forEach((docy) => {
      cities.push({ id: docy.id, ...docy.data() });
    });
    orgs.value = cities;
  });
});
const selectOrg = async (org) => {
  const userRef = doc(db, "users", auth.currentUser.uid);
  await updateDoc(userRef, {
    "settings.active_org": org.id,
    "settings.org_name": org.name,
  });
  setTimeout(() => {
    setStartEndDate(org.fy_start);
  }, 2000); //give 2 seconds time for db to update
};
function getFinancialYearStartEnd(startMonth) {
  const today = dayjs(); // Get today's date
  const currentYear = today.year();

  // Financial year starts in the given startMonth (e.g., April)
  const financialYearStart = dayjs(`${currentYear}-${startMonth}-01`);

  // If today is before the financial year start date, it belongs to the previous financial year
  if (today.isBefore(financialYearStart)) {
    return {
      start: financialYearStart.subtract(1, "year").format("YYYY-MM-DD"),
      end: financialYearStart.subtract(1, "day").format("YYYY-MM-DD"),
    };
  } else {
    // Otherwise, the financial year starts in the current year
    return {
      start: financialYearStart.format("YYYY-MM-DD"),
      end: financialYearStart
        .add(1, "year")
        .subtract(1, "day")
        .format("YYYY-MM-DD"),
    };
  }
}

const setStartEndDate = async (fy_start) => {
  if (!store.start_date || !store.end_date) {
    const userRef = doc(db, "users", auth.currentUser.uid);
    await updateDoc(userRef, {
      "settings.start_date": getFinancialYearStartEnd(
        months.value.indexOf(fy_start) + 1
      ).start,
      "settings.end_date": getFinancialYearStartEnd(
        months.value.indexOf(fy_start) + 1
      ).end,
    });
  }
};
</script>
